import { render, staticRenderFns } from "./CTable.vue?vue&type=template&id=a7e6d706&scoped=true&"
import script from "./CTable.vue?vue&type=script&lang=js&"
export * from "./CTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e6d706",
  null
  
)

export default component.exports